import React from "react";
import { TextField } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

const CustomizedInputs = styled((props) => (
  <TextField InputProps={{ disableUnderline: true }} {...props} />
))(({ theme }) => ({
  "& .MuiFilledInput-root": {
    border: "1px solid #7747c0",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: theme.palette.mode === "light" ? "#fcfcfb" : "#2b2b2b",
    transition: theme.transitions.create([
      "border-color",
      "background-color",
      "box-shadow",
    ]),
    "&:hover": {},
    "&.Mui-focused": {
      backgroundColor: "transparent",
      boxShadow: `${alpha("#f7b500", 0.25)} 0 0 0 2px`,
      borderColor: "#f7b500",
    },
  },
  "& label.Mui-focused": {
    color: "#7747c0",
  },
}));
export const Input = (props) => {
  return (
    <CustomizedInputs variant="filled" style={{ marginTop: 11 }} {...props} />
  );
};
